Librarian.Modules.ImageLink = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-imagelink-",
        imagePath: null,
        imageAlt: null,
        onClick: null,
        onPostRender: null,
        header: null,
        message: null,
        clickImage: false,
        linkText: null
    },

    initialize: function (options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function () {
        if (!this.wrapperEl)
            return;

        this.parent();

        if (this.containerEl) {
            $(this.containerEl).destroy();
            this.containerEl = null;
        }

        if (this.options.imagePath) {
            var imageEl = new Element("img", {
                "class": (this.options.classPrefix || '') + "image",
                "alt": this.options.alt || '',
                "src": this.options.imagePath
            }).injectInside(this.wrapperEl);
            if (this.options.clickImage && typeof this.options.onClick == "function")
                imageEl.addOnClick(this.options.onClick);
        }

        if (this.options.header) {
            new Element("div", {
                "class": (this.options.classPrefix || '') + "title",
                "text": this.options.header || ''
            }).injectInside(this.wrapperEl);
        }

        if (this.options.message) {
            new Element("div", {
                "class": (this.options.classPrefix || '') + "message",
                "html": this.options.message || ''
            }).injectInside(this.wrapperEl);
        }

        if (this.options.linkText) {
            var linkEl = new Element("div", {
                "class": (this.options.classPrefix || '') + "link",
                "html": this.options.linkText || ''
            }).injectInside(this.wrapperEl);
            if (typeof this.options.onClick == "function")
                linkEl.addOnClick(this.options.onClick);
        }

        if (this.options.onPostRender)
            this.options.onPostRender(this.wrapperEl, this.options.onClick);
    }
});